import * as core from '../../../../../../../core'

import { query } from './proposal-personnel-table.query'

export const RESOURCE = {
  payload: {
    alias: 'proposal.personnel.table',
    description: 'Table used to display and explore personnel on a proposal',
    name: 'Proposal Personnel Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
